import React from 'react';

import PlasticBuckets from './PlasticBuckets';

import Specialpe from './Specialpe';



const Pbseriesph = () => {
    return (
        <div>
      <PlasticBuckets />
            <Specialpe />

        </div>
    );
};
export default Pbseriesph;
